/* ==========================================================================
   Natural Nectar — money formatting

   One job: format an amount in paise the same way Liquid's `money` filter
   would, so a price rendered by the server and the same price rewritten by JS
   are never spelled differently.

   This exists because the obvious shortcut is wrong. Intl.NumberFormat with
   currency INR produces "₹300", while this shop's money format is
   "Rs. {{amount}}" and every server-rendered price on the site reads
   "Rs. 300.00". Mixing the two made the free-delivery bar switch notation the
   instant the cart changed. Rather than guess, we read the shop's own format
   string and fill it in — change the format in Shopify admin and both the
   server and this file follow it automatically.

   Mirrors Shopify's reference implementation, including the token names, so
   any format string the admin can produce is handled.
   ========================================================================== */

window.nnFormatMoney = function nnFormatMoney(cents, format) {
  const placeholder = /\{\{\s*(\w+)\s*\}\}/;
  const template = format || 'Rs. {{amount}}';
  const amount = typeof cents === 'string' ? cents.replace('.', '') : cents;

  if (isNaN(amount) || amount == null) return '';

  function withDelimiters(number, precision, thousands, decimal) {
    const p = precision == null ? 2 : precision;
    const t = thousands == null ? ',' : thousands;
    const d = decimal == null ? '.' : decimal;

    const fixed = (number / 100).toFixed(p);
    const parts = fixed.split('.');
    const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t);

    return parts[1] ? whole + d + parts[1] : whole;
  }

  const match = template.match(placeholder);
  // A format string with no token at all is malformed; return it untouched
  // rather than throwing inside a render path.
  if (!match) return template;

  let value;
  switch (match[1]) {
    case 'amount_no_decimals':
      value = withDelimiters(amount, 0);
      break;
    case 'amount_with_comma_separator':
      value = withDelimiters(amount, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = withDelimiters(amount, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = withDelimiters(amount, 2, "'");
      break;
    case 'amount_no_decimals_with_space_separator':
      value = withDelimiters(amount, 0, ' ');
      break;
    case 'amount_with_space_separator':
      value = withDelimiters(amount, 2, ' ', ',');
      break;
    case 'amount_with_period_and_space_separator':
      value = withDelimiters(amount, 2, ' ', '.');
      break;
    case 'amount':
    default:
      value = withDelimiters(amount, 2);
      break;
  }

  return template.replace(placeholder, value);
};
